import React, { createContext, useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";

const VideoPlayerContext = createContext();

export const VideoPlayerProvider = ({ children }) => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [title,setTitle] = useState(null);

  useEffect(() => {
    // Simple screen size detection
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openVideo = (url) => setVideoUrl(url);
  const closeVideo = () => setVideoUrl(null);
  const titleName = (title) => setTitle(title);

  return (
    <VideoPlayerContext.Provider value={{ openVideo, closeVideo,titleName }}>
      {children}
      {videoUrl &&
        ReactDOM.createPortal(
          isMobile ? (
            // Mobile → Center modal
            <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-[99999]">
              <div className="relative w-11/12 max-w-md">
                {   title &&
                    <h2 className="text-white font-semibold">{title}</h2>
                }
                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    <video
                    src={videoUrl}
                    controls
                    autoPlay
                    className="w-full h-64 object-cover"
                    />
                    <button
                    onClick={closeVideo}
                    className="absolute top-0 right-0 bg-red-500 text-white px-3 py-1 text-sm rounded font-semibold"
                    >
                    ✕
                    </button>
                </div>
              </div>
            </div>
          ) : (
            // Desktop → Bottom-right floating
            <div className="fixed bottom-4 right-4 bg-black shadow-xl rounded-lg overflow-hidden z-[99999]"
                style={{ width: "460px", maxWidth: "80vw", height: "260px" }}
            >
              <video
                src={videoUrl}
                controls
                autoPlay
                className="w-full h-full object-cover"
              />
              <button
                onClick={closeVideo}
                className="absolute top-1 right-1 bg-red-500 text-white px-2 py-1 text-xs rounded"
              >
                ✕
              </button>
            </div>
          ),
          document.body
        )}
    </VideoPlayerContext.Provider>
  );
};

export const useVideoPlayer = () => useContext(VideoPlayerContext);
